import { render, staticRenderFns } from "./ChamadoRecebidoLista.vue?vue&type=template&id=5295684d&scoped=true"
import script from "./ChamadoRecebidoLista.vue?vue&type=script&lang=js"
export * from "./ChamadoRecebidoLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5295684d",
  null
  
)

export default component.exports